import axios from 'axios';

export default {
    getHeaderNav() {
        return axios.get('/eapi/nav-header.json');
    },
    getFooterNav() {
        return axios.get('/eapi/nav-footer.json');
    },
    getPartners() {
        return axios.get('/eapi/partners.json');
    },
    getSocial() {
        return axios.get('/eapi/social.json');
    },
};
